module.exports = __webpack_public_path__ + "img/8-small.5647ff28.png";